module.exports = __webpack_public_path__ + "app/assets/images/man20-dc34ba8a61aad18bcc154fd564cc5667.jpg";